import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

export const profileAdaptor = createEntityAdapter({})
const initialProfile = profileAdaptor.getInitialState()
export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getProfile: builder.query({
            query: () => '/b2g/eco-admin/authentication/profile',
            transformResponse: responseData => {
                if (responseData?.status === false) {
                    throw new Error(responseData?.statusCode)
                }
                return profileAdaptor.setAll(initialProfile, responseData?.data)
            },
            providesTags: (result, error, arg) => {
                if (error) {
                    return []
                }
                if (!error && result?.ids) {
                    return [
                        { type: 'Profile', id: "List" },
                        ...result.ids.map(id => ({ type: 'Profile', id }))
                    ]
                }
            }
        }),
        addNewProfile: builder.mutation({
            query: body => ({
                url: '/b2g/eco-admin/authentication/profile',
                method: 'POST',
                body: body
            }),
            invalidatesTags: [
                { type: 'Profile', id: 'List' }
            ]
        }),
    })
})

export const {
    useGetProfileQuery,
    useAddNewProfileMutation,
} = extendedApiSlice

